import { motion, useInView } from "framer-motion"
import { graphql, Link, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import { Autoplay, Navigation } from "swiper"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/pagination"
import { Swiper, SwiperSlide } from "swiper/react"
import ImageOpt from "./ImageOpt"

const DestinationsListing = ({ module }) => {
  const ref = useRef(null)
  const [hasPlayed, setHasPlayed] = useState(false)
  const isInView = useInView(ref)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }

  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  const dnData = useStaticQuery(graphql`
    query dnQuery {
      allWpDestination(sort: { date: ASC }) {
        nodes {
          title
          excerpt
          uri
          featuredImage {
            node {
              altText
              mediaItemUrl
            }
          }
          destinationContent {
            gallerySlider {
              image {
                altText
                mediaItemUrl
                title
              }
            }
          }
        }
      }
    }
  `)

  const dndata = dnData.allWpDestination.nodes

  if (module.hideSection === "no") {
    return (
      <React.Fragment>
        <motion.section
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`destination-listing-slider py-85 xlscreen:py-75 mdscreen:py-40 bg-white-400 pattern-zebra ${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="container-fluid-lg"
          >
            {module?.heading && (
              <motion.div
                variants={animFade}
                className="title title-grey grey-separator-both"
              >
                <h2 className="uppercase">{module.heading}</h2>
              </motion.div>
            )}
          </motion.div>
          {dndata.map((item, i) => (
            <div
              className="listing-slider pt-80 xlscreen:pt-70 mdscreen2:pt-50"
              key={i}
            >
              <div
                className={`container-fluid-xl ${
                  i % 2 === 0 ? "lg:!pr-0" : "lg:!pl-0"
                }`}
              >
                <div className="flex flex-wrap items-center">
                  <motion.div
                    variants={animFade}
                    className={`lgscreen:w-full w-6/12 flex items-center order-1 ${
                      i % 2 === 0 ? "lg:order-2" : "lg:order-1"
                    }`}
                  >
                    <div className="w-full">
                      <div className="slider-main relative">
                        <Swiper
                          slidesPerView={1}
                          speed={1000}
                          centeredSlides={true}
                          modules={[Autoplay, Navigation]}
                          navigation={{
                            nextEl: `.listing_swiperBtn_next-${i}`,
                            prevEl: `.listing_swiperBtn_prev-${i}`,
                            disabledClass: "btn-disabled",
                          }}
                        >
                          {item?.destinationContent.gallerySlider.map(
                            (galleryItem, j) => (
                              <SwiperSlide key={j}>
                                <div className="img">
                                  <ImageOpt
                                    imgData={galleryItem.image.mediaItemUrl}
                                    imgAlt={galleryItem.image.title}
                                    imgClass=""
                                    width={2000}
                                    height={1000}
                                    imgLoad="lazy"
                                  />
                                </div>
                              </SwiperSlide>
                            )
                          )}
                        </Swiper>
                        <div className="swiper-arrow flex justify-end gap-x-25 absolute bottom-30 right-45 w-full z-9 lgscreen:right-30 lgscreen:bottom-20">
                          <button
                            className={`swiper-btn w-[42px] h-[42px] lgscreen:w-[35px] lgscreen:h-[35px] rounded-100 bg-opacity-10 border-2 border-white-100 flex flex-wrap justify-center items-center transition-common listing_swiperBtn_prev-${i}`}
                          >
                            <img
                              src="../../images/swiper-arrowPrev-white.svg"
                              width={20}
                              height={20}
                              loading="lazy"
                              alt="Arrow"
                              className="lgscreen:h-[15px] lgscreen:w-[15px]"
                            />
                          </button>
                          <button
                            className={`swiper-btn w-[42px] h-[42px] lgscreen:w-[35px] lgscreen:h-[35px] rounded-100 bg-opacity-10 border-2 border-white-100 flex flex-wrap justify-center items-center transition-common listing_swiperBtn_next-${i}`}
                          >
                            <img
                              src="../../images/swiper-arrowNext-white.svg"
                              width={20}
                              height={20}
                              loading="lazy"
                              alt="Arrow"
                              className="lgscreen:h-[15px] lgscreen:w-[15px]"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                  <div
                    className={`lgscreen:w-full w-6/12 order-2 ${
                      i % 2 === 0
                        ? "lg:order-1 lg:pr-30"
                        : "lg:order-2 lg:pl-30"
                    }`}
                  >
                    <div
                      className={`lg:max-w-[551px] text-center ${
                        i % 2 === 0 ? "mr-auto" : "ml-auto"
                      } relative z-10`}
                    >
                      <motion.div
                        variants={animFade}
                        className="title title-grey pt-25"
                      >
                        <h3 className="uppercase font-500 tracking-0.04em">
                          {item.title}
                        </h3>
                      </motion.div>
                      {item?.excerpt && (
                        <motion.div
                          variants={animFade}
                          className="content pt-25"
                        >
                          {parse(item.excerpt)}
                        </motion.div>
                      )}
                      <motion.div
                        variants={animFade}
                        className="flex flex-wrap justify-center gap-x-30 lg:gap-x-40 xl:gap-x-50 pt-30"
                      >
                        <Link to={item.uri} className="btn btn-underline-grey">
                          discover more
                        </Link>
                      </motion.div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </motion.section>
      </React.Fragment>
    )
  }
  return null
}

export default DestinationsListing
export const PageDestinationsListingFragment = graphql`
  fragment PageDestinationsListingFragment on WpPage_Pagecontent_PageContent_DestinationsListing {
    extraClass
    extraId
    hideSection
    heading
  }
`
